import * as types from '../types.js';
import obs_load_warehouses_create_outputs from '../types/obs_load_warehouses_create_outputs.js';

export default {

	html: `
		<style>
			#create-outputs #company_id		{ width: 100%; }
			#create-outputs #warehouse_id	{ width: 100%; max-width: 100%; box-sizing: border-box; }
		</style>
		<form id="create-outputs" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="title" id="co-wh-title">
				Armazém físico
			</div>
			<p id="co-wh-hint" class="hint" style="margin:0.35rem 0 0.75rem;font-size:0.85rem;line-height:1.35;color:#444;">
			</p>
			<div class="mtl fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Somente armazéns físicos ativos; obrigatório se houver mais de um" id="co-wh-label">Armazém físico (lista)
					<select id="warehouse_id" disabled>
						<option value="">— Escolha a empresa primeiro —</option>
					</select>
				</label>
			</div>
			<div class="ckb">
				<label title="Incluir itens com validade vencida na busca?">
					<input id="include_expired" type="checkbox" class="dib">&nbsp;Incluir&nbsp;expirados
				</label>
				<label title="Reservar estoques ou apenas estimar percentuais de atendimento?">
					Reservar&nbsp;estoques&nbsp;<input id="reserve_flag" type="checkbox" class="dib">
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Gerar <span id="count"></span> saídas</button>
			</div>
		</form>
	`,

	form:
	{
		selector: '#create-outputs',
		init(formset)
		{
			formset.form.eraseValues();
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{
			properties: { selector: '#warehouse_id' },
			types: [
				types.pubsub(),
				types.observer('company_id'),
				obs_load_warehouses_create_outputs(),
			],
		},
		{ properties: { selector: '#include_expired' }, types: [types.checkbox()] },
		{ properties: { selector: '#reserve_flag' }, types: [types.checkbox()] },
	]

};
